export enum LoginStatusTypes {
  Approved = 1,
  Declined = 2,
  Suspended = 3,
  TCFlag = 4,
}
